<template>
    <div class="profile">
        <div class="user">
            <div class="user__avatar">
                <common-rating-avatar :user="physician" :size="avatarSize"></common-rating-avatar>
            </div>

            <div class="visit-layout">
                <h3 class="patient-name">{{ physician.firstName }} {{ physician.lastName }}</h3>
                <p v-if="physician.lastReferralCreatedDateTime" class="visit">
                    {{ $t('modals.member_card.lastvisit.title') }} {{ formattedDate }}
                </p>
            </div>
        </div>
        <div class="refer-patient-btn">
            <common-button
                :label="$t('modals.refer_patient.buttons.refer')"
                size="large"
                type="refer-patient"
                :isClicked="isDropdownOpen"
                @click="toggleDropdown"
            ></common-button>
            <common-dropdown
                v-clickaway="closeDropdown"
                class="refer-patient-dropdown"
                :isOpen="isDropdownOpen"
                :hasArrow="false"
                bgColor="gray"
                arrowPositionY="top"
                arrowPositionX="right"
            >
                <common-dropdown-items
                    :menuItems="menuItems"
                    :isReferPatient="true"
                    @item-clicked="itemClicked"
                ></common-dropdown-items>
            </common-dropdown>
        </div>
        <direct-referral
            v-if="isDirectReferralModalOpen"
            :activePracticeType="practiceType"
            @location-selected="toggleModal"
            @close="toggleModal"
        ></direct-referral>
    </div>
</template>
<script>
    import dayjs from 'dayjs'
    import PhysicianMixin from 'mixins/PhysicianMixin'
    import DirectReferral from 'components/page-elements/referrals/DirectReferral'
    import PracticeTypeEnum from '@/enums/PracticeTypeEnum'

    export default {
        mixins: [PhysicianMixin],
        components: {
            DirectReferral,
        },
        props: {
            physician: { type: Object, required: true },
        },
        data() {
            return {
                isDropdownOpen: false,
                isDirectReferralModalOpen: false,
                selectedInsurance: [],
                PracticeTypeEnum: PracticeTypeEnum,
                practiceType: null,
            }
        },
        computed: {
            menuItems() {
                return [
                    {
                        name: this.$t('layouts.app.topnav.direct_referral'),
                        description: this.$t('layouts.app.topnav.direct_referral_description'),
                        icon: 'direct-referral',
                        subItems: [
                            {
                                name: this.$t('layouts.app.topnav.direct_physican'),
                                payload: { matchReferral: true, practiceType: PracticeTypeEnum.PHYSICIAN },
                            },
                            {
                                name: this.$t('layouts.app.topnav.direct_ancillary'),
                                payload: { matchReferral: true, practiceType: PracticeTypeEnum.ANCILLARY },
                            },
                        ],
                    },
                    {
                        name: this.$t('layouts.app.topnav.match_referral'),
                        description: this.$t('layouts.app.topnav.match_referral_description'),
                        icon: 'match-referral',
                        subItems: [
                            {
                                name: this.$t('layouts.app.topnav.match_physican'),
                                payload: {
                                    directReferral: true,
                                    practiceType: PracticeTypeEnum.PHYSICIAN,
                                    patientId: this.$route.params.id,
                                },
                            },
                            {
                                name: this.$t('layouts.app.topnav.match_ancillary'),
                                payload: { directReferral: true, practiceType: PracticeTypeEnum.ANCILLARY },
                            },
                        ],
                    },
                    {
                        name: this.$t('layouts.app.topnav.eprescribe'),
                        description: this.$t('layouts.app.topnav.eprescribe_description'),
                        icon: 'eprescribe',
                        payload: { eprescribe: true, route: 'referrals.eprescribe' },
                        hidden: this.$auth.isUserPracticeOther(),
                        disabled: false,
                    },
                ]
            },
            avatarSize() {
                switch (this.size) {
                    case 'medium':
                        return 'user-context'
                    default:
                        return 'member-switch'
                }
            },
            formattedDate() {
                return this.physician.lastReferralCreatedDateTime
                    ? dayjs(this.physician.lastReferralCreatedDateTime).format('MMMM D, YYYY')
                    : undefined
            },
        },
        methods: {
            toggleDropdown() {
                this.isDropdownOpen = !this.isDropdownOpen
            },
            closeDropdown() {
                this.isDropdownOpen = false
            },
            toggleModal(practiceType) {
                this.practiceType = practiceType
                this.isDirectReferralModalOpen = !this.isDirectReferralModalOpen
            },
            changeInsurance(event) {
                this.selectedInsurance = event
            },
            openMatchReferral(practiceType, patientId = null) {
                const query = { practiceType: practiceType }
                if (patientId) {
                    query.patientId = patientId
                }
                this.$router.push({ name: `pool.new`, query })
            },

            itemClicked(payload) {
                if (payload.matchReferral) {
                    this.toggleModal(payload.practiceType)
                }
                if (payload.directReferral) {
                    this.openMatchReferral(payload.practiceType, payload.patientId)
                }

                if (payload.eprescribe) {
                    this.$router.push({ name: payload.route })
                }
            },
        },

        watch: {
            $route() {
                if (this.$route.query?.openModal?.length) {
                    this.toggleModal(this.$route.query.openModal)
                    const query = Object.assign({}, this.$route.query)
                    delete query.openModal
                    this.$router.replace({ query })
                }
            },
        },
    }
</script>
<style lang="scss" scoped>
    @import 'styles/setup/_variables.scss';
    @import 'styles/setup/_mixins.scss';

    .user {
        display: flex;
        align-items: center;
    }
    .profile {
        display: flex;
        justify-content: space-between;
        width: 100%;
        margin: 12px;

        @media (max-width: 768px) {
            flex-direction: column;
            align-items: flex-start;
            gap: 12px;
        }
    }

    .refer-patient-btn {
        position: relative;
    }

    .refer-patient-dropdown {
        right: 5px;
        min-width: 300px;

        @include breakpoint(tablet-small) {
            min-width: unset;
        }
    }
</style>
